import {useNavigate, useParams} from 'react-router-dom'
import {HeaderTitle} from '../../../../../common/HeaderTitle.jsx'
import Wizard from '../../../../../common/wizard/Wizard.jsx'
import {
    EtapInicjacji,
    EtapPrzygotowania, EtapRealizacji, EtapZamykania,
    Podsumowanie,
    Start
} from '../../../lib/components/planHarmForm/ph1/pages/index.js'
import {useSelector} from 'react-redux'

const ViewPlanHarmForm = () => {
    const WZOR_NAME = 'ph1'
    const {rejestrId, planHarmId, tryb} = useParams()
    const rola = useSelector((state) => state.user.role)
    const rolaParam = rola === 'oper' ? 'oper/' : '/'
    const navigate = useNavigate();

    const dataUrl = planHarmId
        ? `${rolaParam}plan-harm/${rejestrId}/${planHarmId}`
        : `${rolaParam}plan-harm/${rejestrId}`

    return (
        <>
            <HeaderTitle
                home
                nav
                size={'fs-2'}
                breadcrumbLinks={[
                    {
                        label: 'Wszystkie projekty',
                        to: `/${rola}/rejestr/lista`,
                    },
                    {label: 'Wypełnij plan harmonogramu'},
                ]}
                data={[['ID', rejestrId]]}
                destination={`/${rola}/rejestr/lista`}
                title={'Wypełnij plan harmonogram'}
            />
            <Wizard
                debug
                mode={tryb}
                name={WZOR_NAME}
                dataUrl={dataUrl}
                validationUrl={`${rolaParam}plan-harm/${rejestrId}/podsumowanie`}
                saveUrl={`${rolaParam}plan-harm`}
                mappingUrl={`${rolaParam}plan-harm/wzor/${WZOR_NAME}`}
                //acceptButtons={acceptButtons}
                saveOnPageChange={true}
                stateForPage={false}
                saveAndQuitCallback={() => navigate(`/${rola}/rejestr/lista`)}
                cancelCallback={() => navigate(`/${rola}/rejestr/lista`)}
                filterByCategory={false}
                pages={[
                    {name: 'start', form: <Start/>},
                    {name: 'etap_inicjacji', form: <EtapInicjacji/>},
                    {name: 'etap_przygotowania', form: <EtapPrzygotowania/>},
                    {name: 'etap_realizacji', form: <EtapRealizacji/>},
                    {name: 'etap_zamykania', form: <EtapZamykania/>},
                    {
                        name: 'podsumowanie',
                        form: <Podsumowanie/>,
                        summary: true,
                    },
                ]}
            />
        </>
    )
}

export default ViewPlanHarmForm
